import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Common } from '../../Assets/styles/common';
import { Box } from '../../CommonUI/Layout';
import { Text } from 'ilenia';
import { LinkTrackingProps } from '../../Model';

interface LinkProps extends React.HTMLProps<HTMLAnchorElement> {
    label: string;
    track?: LinkTrackingProps;
    pl?: number;
    pr?: number;
    mt?: number;
    onClick?: () => void;
}

export const Link: React.SFC<LinkProps> = (props) => {
    const {label, pl, pr, mt, track, onClick, ...rest} = props;
    const onClickHandler = () => {
        const { source, ...restTrack} = track!;
        if (onClick) {
            onClick();
        }
        if (track) {
            analytics.track('Integration Link Clicked', {
                context: 'Ecommscript integration app',
                location: window.location.pathname,
                integration: source,
                ...restTrack
            });
        }
    };
    return (
        <Box pl={pl || pl === 0 ? pl : 20} pr={pr || pr === 0 ? pr : 20} mt={mt} width="auto">
            <a className={css(styles.link, styles.linkPseudo)} onClick={onClickHandler} target="_blank" {...rest}>
                <Text id={label}/>
            </a>
        </Box>
    );
};

const styles = StyleSheet.create({
    link: {
        font: Common.Font.normalText,
        fontStretch: 'normal',
        lineHeight: '1.43',
        letterSpacing: 'normal',
        color: '#368cd7',
        textDecoration: 'none'
    },
    linkPseudo: {
        ':hover': {
            color: '#2471b3',
            cursor: 'pointer'
        },
        ':focus': {
            borderRadius: '2px',
            border: 'solid 2px #54a5e5',
            outlineStyle: 'none'
        }
    }
});



// WEBPACK FOOTER //
// ./src/CommonUI/Control/Link.tsx